import { OBM_API_URL } from '@shared/constants/API.constants';

export const listClustersConfig = ({
    clientId,
    organizationId,
}) => ({
    url: 'clusters',
    method: 'GET',
    params: { clientId, organizationId },
    baseURL: OBM_API_URL,
});
